import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-drtv-stat-icon',
    templateUrl: './drtv-stat-icon.component.html',
    styleUrls: ['./drtv-stat-icon.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DrtvStatIconComponent implements OnInit {
  @Input() icon = '';
  @Input() percentage = '';

  constructor() { }

  ngOnInit(): void {
  }

}
